module.exports = function fail(message) {
  throw new TypeError('[tcomb] ' + message);
};


//////////////////
// WEBPACK FOOTER
// /data/www/SGDBackend-Nex2/~/tcomb/lib/fail.js
// module id = 700
// module chunks = 0